<template>
  <div v-if="track" class="apple-dialog-track">
    <img :src="cover" alt="" @error="fallback" />
    <div><strong :title="track.title">{{ track.title }}</strong><small :title="subtitle">{{ subtitle }}</small><slot /></div>
  </div>
</template>
<script>
import { runtime } from '../../bridge';
export default {
  name:'AppleDialogTrack', props:{track:Object,album:{type:Boolean,default:true}},
  computed:{cover(){return runtime.cover(this.track);},subtitle(){return [this.track.artists?.join(' · '),this.album&&this.track.album].filter(Boolean).join(' · ');}},
  methods:{fallback(event){const cover=runtime.cover();if(event.target.src!==cover)event.target.src=cover;}},
};
</script>
<style scoped>
.apple-dialog-track{display:flex;align-items:center;gap:12px;min-width:0}.apple-dialog-track>img{flex:none;width:var(--apple-dialog-artwork-size,52px);height:var(--apple-dialog-artwork-size,52px);object-fit:cover;border-radius:5px;box-shadow:0 1px 4px #0002}.apple-dialog-track>div{min-width:0;flex:1;display:grid;gap:5px}.apple-dialog-track strong,.apple-dialog-track small{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.apple-dialog-track strong{font-size:var(--apple-dialog-title-size,14px);line-height:1.3;font-weight:600}.apple-dialog-track small{font-size:var(--apple-dialog-subtitle-size,12px);line-height:1.3;color:var(--apple-muted,var(--color-secondary))}
</style>
